"use client";

import { create } from "zustand";
import type { AppAccess, StaffProfile } from "@/types/auth";
import { logout as logoutRequest } from "@/lib/api/auth";

interface AuthState {
  profile: StaffProfile | null;
  appAccess: AppAccess | null;
  isHydrated: boolean;
  isLoggingOut: boolean;
  setProfile: (profile: StaffProfile) => void;
  setAppAccess: (access: AppAccess | null) => void;
  clearProfile: () => void;
  setHydrated: (value: boolean) => void;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  profile: null,
  appAccess: null,
  isHydrated: false,
  isLoggingOut: false,
  setProfile: (profile) => set({ profile, isHydrated: true }),
  setAppAccess: (appAccess) => set({ appAccess }),
  clearProfile: () => set({ profile: null, appAccess: null }),
  setHydrated: (isHydrated) => set({ isHydrated }),
  logout: async () => {
    set({ isLoggingOut: true });
    await logoutRequest();
  },
}));
